import type { IconSvgObject } from './types';

const JoggerPantsIcon: IconSvgObject = [
  ["path", { d: "M10 7.77778L12 5L15 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6.00003 5V3C6.00003 2.44772 6.44775 2 7.00003 2H17C17.5523 2 18 2.44772 18 3V5M6.00003 5L3.00003 22H8.00003L12 12L16 22H21L18 5M6.00003 5H18", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default JoggerPantsIcon;
